import { render, staticRenderFns } from "./SectionsTable.vue?vue&type=template&id=23c7d9ee&"
import script from "./SectionsTable.vue?vue&type=script&lang=js&"
export * from "./SectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SectionsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports